export enum SPACING {
  _4 = '4px',
  _6 = '6px',
  _8 = '8px',
  _10 = '10px',
  _12 = '12px',
  _14 = '14px',
  _16 = '16px',
  _18 = '18px',
  _20 = '20px',
  _22 = '22px',
  _24 = '24px',
  _32 = '32px',
  _40 = '40px',
  _44 = '44px',
  _48 = '48px',
  _56 = '56px',
  _64 = '64px',
}
